import classNames from "classnames";
import {ReactNode} from "react";
import {Modal, ModalProps} from "react-bootstrap";

import {RequiredFieldsNote} from "@/components/form/requiredFieldsNote/RequiredFieldsNote.tsx";

import {FormModalFooter} from "./FormModalFooter.tsx";

interface FormModalProps extends ModalProps {
  hasSubmitButton?: boolean;
  submitBtnText?: string;
  hasCancelButton?: boolean;
  cancelBtnText?: string;
  title: ReactNode;
  formId?: string;
  disabled?: boolean;
  onCancel?: () => void;
  footer?: ReactNode;
  leftAction?: ReactNode;
  bodyClassName?: string;
  contentClassName?: string;
  hasRequiredFields?: boolean;
}

export const FormModal = ({
  title,
  formId,
  onCancel,
  disabled,
  hasSubmitButton = true,
  submitBtnText,
  hasCancelButton = true,
  cancelBtnText,
  children,
  footer,
  leftAction,
  bodyClassName,
  contentClassName,
  centered = true,
  hasRequiredFields = false,
  ...rest
}: FormModalProps) => {
  return (
    <Modal
      onHide={onCancel}
      {...rest}
      centered={centered}
      backdrop={"static"}
      className="px-lg-4"
      contentClassName={contentClassName}
    >
      <Modal.Header closeButton className="px-lg-4">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={classNames("px-lg-4", bodyClassName)}>
        {hasRequiredFields && <RequiredFieldsNote />}
        {children}
      </Modal.Body>
      {footer || (
        <FormModalFooter
          onCancel={onCancel}
          disabled={disabled}
          formId={formId}
          hasSubmitButton={hasSubmitButton}
          submitText={submitBtnText}
          hasCancelButton={hasCancelButton}
          cancelText={cancelBtnText}
          leftAction={leftAction}
        />
      )}
    </Modal>
  );
};
